import { render, staticRenderFns } from "./CatalogueModal.vue?vue&type=template&id=30c9c8d6&scoped=true&"
import script from "./CatalogueModal.vue?vue&type=script&lang=js&"
export * from "./CatalogueModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueModal.vue?vue&type=style&index=0&id=30c9c8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9c8d6",
  null
  
)

export default component.exports